/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const ReviewRatingStatusEnum = {
    Pending: 'PENDING',
    InProgress: 'IN_PROGRESS',
    Done: 'DONE',
    NotFound: 'NOT_FOUND'
};
/**
 * Check if a given object implements the ReviewRating interface.
 */
export function instanceOfReviewRating(value) {
    return true;
}
export function ReviewRatingFromJSON(json) {
    return ReviewRatingFromJSONTyped(json, false);
}
export function ReviewRatingFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'asin': json['asin'] == null ? undefined : json['asin'],
        'rating': json['rating'] == null ? undefined : json['rating'],
        'reviewCount': json['reviewCount'] == null ? undefined : json['reviewCount'],
        'boughtPastMonth': json['boughtPastMonth'] == null ? undefined : json['boughtPastMonth'],
        'status': json['status'] == null ? undefined : json['status'],
        'scrapedAt': json['scrapedAt'] == null ? undefined : (new Date(json['scrapedAt'])),
        'expiresAt': json['expiresAt'] == null ? undefined : (new Date(json['expiresAt'])),
        'queuedAt': json['queuedAt'] == null ? undefined : (new Date(json['queuedAt'])),
    };
}
export function ReviewRatingToJSON(json) {
    return ReviewRatingToJSONTyped(json, false);
}
export function ReviewRatingToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'asin': value['asin'],
        'rating': value['rating'],
        'reviewCount': value['reviewCount'],
        'boughtPastMonth': value['boughtPastMonth'],
        'status': value['status'],
        'scrapedAt': value['scrapedAt'] == null ? undefined : ((value['scrapedAt']).toISOString()),
        'expiresAt': value['expiresAt'] == null ? undefined : ((value['expiresAt']).toISOString()),
        'queuedAt': value['queuedAt'] == null ? undefined : ((value['queuedAt']).toISOString()),
    };
}
